import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-clinic-details',
  templateUrl: './clinic-details.component.html',
  styleUrls: ['./clinic-details.component.scss']
})
export class ClinicDetailsComponent {
  clinicsData: any;
  infras: any;
  specialitiesData: any[] = [];
  equipmentsData: any[] = [];
  servicesData: any[] = [];
  publications: any = [];
  awards: any = [];
  associations: any = [];
  volunteerings: any = [];
  currCarousel: number = 0;
  carouselImgs: any = [];
  about: string = '';
  facebookUrl: string = '';
  instagramUrl: string = '';
  linkedin: string = '';
  twitterUrl: string = '';
  servicesSize: number = 8;
  viewAll: boolean = false;
  isMobileView: boolean = false;
  clinicId!: any;
  clinicAccountType!: any;


  private scrollListenerAdded = new Set<string>();
  canSlideLeft: boolean = false;
  canSlideRight: boolean = false;
  canSlideLeftSpecialities: boolean = false;
  canSlideRightSpecialities: boolean = false;
  canSlideLeftServices: boolean = false;
  canSlideRightServices: boolean = false;
  canSlideLeftEquipments: boolean = false;
  canSlideRightEquipments: boolean = false;
  canSlideRightAcheivements: boolean = false;
  canSlideLeftAcheivements: boolean = false;
  canSlideLeftDoctors = false;
  canSlideRightDoctors = false;
  isSmallScreen: boolean = false;
  containerClass: string = '';
  achievementsPosition: number = 0;
  totalAchievementsCards: number = 4;

  whyChooseUse: string = '../../../../assets/images/whyChooseUs.png'
  constructor(
    private route: ActivatedRoute,
    private endCustomerService: EndCustomerService,
    private spinnerService: SpinnerService,
    private breakpointObserver: BreakpointObserver
  ) { }
  ngOnInit() {
    const topOfPage = document.querySelector('app-website-header');
    if (topOfPage) {
      topOfPage.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
    this.spinnerService.showSpinner();
    this.route.params.subscribe((res: any) => {
      this.getHospitalDetails(res.id);
    });
    this.slideNxt();
    this.showObserverBreakPoint();
  }
  getHospitalDetails(id: string) {
    this.endCustomerService.hospitalDetails(id).subscribe((res: any) => {
      this.clinicsData = res?.data;
      this.clinicId = this.clinicsData?.id;
      this.updateSlideCondition();
      this.clinicAccountType = this.clinicsData?.account?.name;
      this.about = this.clinicsData?.aboutId?.about;
      this.facebookUrl = this.clinicsData?.aboutId?.facebookUrl;
      this.instagramUrl = this.clinicsData?.aboutId?.instagramUrl;
      this.linkedin = this.clinicsData?.aboutId?.linkedin;
      this.twitterUrl = this.clinicsData?.aboutId?.twitterUrl;
      this.infras = this.clinicsData?.infras[0];
      this.publications = (this.clinicsData?.moreInfos[0]?.publications || []).sort((a: any, b: any) => {
        const dateA = new Date(a?.publicationDate).getTime();
        const dateB = new Date(b?.publicationDate).getTime();
        return dateB - dateA;
      });
      this.awards = (this.clinicsData?.moreInfos[0]?.awards || []).sort((a: any, b: any) => {
        const dateA = new Date(a?.awardDate).getTime();
        const dateB = new Date(b?.awardDate).getTime();
        return dateB - dateA;
      });
      this.associations = (this.clinicsData?.moreInfos[0]?.associations || []).sort((a: any, b: any) => {
        const dateA = new Date(a?.fromDate).getTime();
        const dateB = new Date(b?.fromDate).getTime();
        return dateB - dateA;
      });
      this.volunteerings = (this.clinicsData?.moreInfos[0]?.volunteerings || []).sort((a: any, b: any) => {
        const dateA = new Date(a?.fromDate).getTime();
        const dateB = new Date(b?.fromDate).getTime();
        return dateB - dateA;
      });
      this.clinicsData.carouselImages.forEach((caro: any) => {
        this.carouselImgs.push(caro.carouselImages);
      });
      this.getSpecialities();
      this.getEquipments();
      this.getServices();
      if (this.clinicsData?.qrCodeURL === undefined) {
        this.spinnerService.showSpinner();
        this.generateQRCode();
        this.spinnerService.hideSpinner();
      }
    })
  }
  getSpecialities() {
    this.endCustomerService.specialities().subscribe((res: any) => {
      let lst: any[] = [];
      const specialities: any[] = [];
      this.clinicsData.specialityInfos.forEach((s: any) => {
        lst.push(s.specialityInfoId);
      })
      res.data.forEach((data: any) => {
        if (lst.includes(data.id) && lst?.length !== 0) {
          specialities.push([data.name, data.imageUrl]);
        }
      })
      this.specialitiesData = specialities;
    });
  }

  getEquipments() {
    this.endCustomerService.equipments().subscribe((res: any) => {
      let lst: any[] = [];
      const equipments: any[] = [];
      if (this.clinicsData?.equipments.length !== 0) {
        this.clinicsData.equipments.forEach((e: any) => {
          lst.push(e.equipmentInfoId);
        })
        res.data.forEach((data: any) => {
          if (lst.includes(data.id) && lst?.length !== 0) {
            equipments.push(data);
          }
        })
      }
      this.equipmentsData = equipments;
    });
  }

  getServices() {
    this.endCustomerService.services().subscribe((res: any) => {
      let lst: any[] = [];
      this.clinicsData.serviceInfos.forEach((s: any) => {
        lst.push(s.serviceInfoId);
      })
      res.data.forEach((data: any) => {
        if (lst.includes(data.id) && lst?.length !== 0) {
          this.servicesData.push([data.name, data.imageUrl]);
        }
      })
      this.spinnerService.hideSpinner();
    });
  }

  slide(direction: string, containerClass: string) {
    let container: HTMLElement | null = null;

    if (containerClass === 'clinic-acheivements-contributions') {
      container = document.querySelector('.cards-content-container') as HTMLElement;
    } else {
      container = document.querySelector(`.${containerClass}`) as HTMLElement;
    }

    if (!container) return;
  
    let scrollAmount: number;
  
    if (containerClass === 'ourAdvanced-container') {
      const cardElement = container.querySelector('.imgsEquipments') as HTMLElement;
      if (!cardElement) return;
  
      const cardWidth = cardElement.offsetWidth + 20;
      const visibleCards = Math.floor(container.clientWidth / cardWidth);
      let cardsToScroll = visibleCards;
      if (cardsToScroll < 1) cardsToScroll = 1;
  
      scrollAmount = direction === 'right' ? cardWidth * cardsToScroll : -cardWidth * cardsToScroll;
  
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  
      setTimeout(() => {
        this.updateScrollButtons('ourAdvanced-container');
      }, 300);
  
    } else {
      scrollAmount = container.clientWidth / 2;
  
      if (direction === 'left') {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else if (direction === 'right') {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
  
      const updateArrows = () => {
        if (containerClass === 'clinic-acheivements-contributions') {
          this.canSlideLeftAcheivements = container!.scrollLeft > 10;
          this.canSlideRightAcheivements = container!.scrollLeft < (container!.scrollWidth - container!.clientWidth - 10);
        }
      };
  
      updateArrows();
      setTimeout(updateArrows, 500);
    }
  }

  private updateScrollButtons(containerClass: string) {
    const container = document.querySelector(`.${containerClass}`) as HTMLElement;
    if (!container) return;

    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    this.canSlideLeft = container.scrollLeft > 0;
    this.canSlideRight = container.scrollLeft < maxScrollLeft;
    if (container.scrollWidth > container.clientWidth && container.scrollLeft === 0) {
      this.canSlideRight = true;
    }

    switch (containerClass) {
      case 'clinic-imgs-container':
        this.canSlideLeftDoctors = this.canSlideLeft;
        this.canSlideRightDoctors = this.canSlideRight;
        break;
      case 'ourAdvanced-container':
        this.canSlideLeftEquipments = this.canSlideLeft;
        this.canSlideRightEquipments = this.canSlideRight;
        break;
      case 'bestServices-container':
        this.canSlideLeftServices = this.canSlideLeft;
        this.canSlideRightServices = this.canSlideRight;
        break;
      case 'specialityContainer':
        this.canSlideLeftSpecialities = this.canSlideLeft;
        this.canSlideRightSpecialities = this.canSlideRight;
        break;
      case 'clinic-acheivements-contributions':
        this.canSlideLeftAcheivements = this.canSlideLeft;
        this.canSlideRightAcheivements = this.canSlideRight;
        break;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initializeScrolling();
      this.enableTouchScrolling();
      this.initTouchScrolling();
      this.setupResponsiveScrolling();
      this.canSlideLeftAcheivements = false;
      this.canSlideRightAcheivements = true;     
    }, 1000);
  }
  initializeScrolling() {
    this.attachScrollListener('clinic-imgs-container');
    this.attachScrollListener('ourAdvanced-container');
    this.attachScrollListener('bestServices-container');
    this.attachScrollListener('specialityContainer');
    this.attachScrollListener('cards-content-container');
  }
  updateAchievementsArrows() {
    this.canSlideLeftAcheivements = this.achievementsPosition > 0;
    this.canSlideRightAcheivements = this.achievementsPosition < this.totalAchievementsCards - 1;
  }

  private attachScrollListener(containerClass: string) {
    const container = document.querySelector(`.${containerClass}`) as HTMLElement;
    if (!container || this.scrollListenerAdded.has(containerClass)) return;

    const checkScrollAvailability = () => {
      if (container.scrollWidth > container.clientWidth) {
        if (containerClass === 'cards-content-container') {
          const totalCards = this.publications.length + this.awards.length +
            this.associations.length + this.volunteerings.length;

          if (totalCards <= 4 && container.scrollWidth - container.clientWidth < 10) {
            this.canSlideRightAcheivements = false;
          } else {
            this.canSlideRightAcheivements = true;
          }

          this.canSlideLeftAcheivements = false;

          container.addEventListener('scroll', () => {
            this.canSlideLeftAcheivements = container.scrollLeft > 10;
            this.canSlideRightAcheivements = container.scrollLeft < (container.scrollWidth - container.clientWidth - 10);
          }, { passive: true });
        } else {
          this.updateScrollButtons(containerClass);

          container.addEventListener('scroll', () => {
            this.updateScrollButtons(containerClass);
          }, { passive: true });
        }

        this.scrollListenerAdded.add(containerClass);
      } else {
        if (containerClass === 'cards-content-container') {
          this.canSlideRightAcheivements = false;
          this.canSlideLeftAcheivements = false;
        }
        setTimeout(checkScrollAvailability, 300);
      }
    };

    checkScrollAvailability();
  }
  checkScreenSize() {
    this.isSmallScreen = window.innerWidth >= 320 && window.innerWidth < 1440;
    setTimeout(() => {
      this.updateScrollButtons('clinic-imgs-container');
      this.updateScrollButtons('ourAdvanced-container');
      this.updateScrollButtons('bestServices-container');
      this.updateScrollButtons('specialityContainer');
      this.updateScrollButtons('cards-content-container');
    }, 500);
  }

  splitText(text: string): string[] {
    const words = text.split(' ');
    if (words.length <= 1) {
      return [text];
    }

    const middleIndex = Math.ceil(words.length / 3);
    const firstLine = words.slice(0, middleIndex).join(' ');
    const secondLine = words.slice(middleIndex).join(' ');
    return [firstLine, secondLine];
  }

  updateSlideCondition() {
    const screenWidth = window.innerWidth;
    const totalCards = this.clinicsData?.members?.length || 0;
    if (screenWidth <= 1536 && screenWidth > 1366) {
      this.containerClass = totalCards <= 4 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.clinicsData?.members?.length > 4;
    } else if (screenWidth <= 1366 && screenWidth > 1024) {
      this.containerClass = totalCards <= 3 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.clinicsData?.members?.length > 3;
    } else if (screenWidth <= 1024) {
      this.containerClass = totalCards <= 2 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.clinicsData?.members?.length > 2;
    } else {
      this.containerClass = totalCards <= 5 ? 'less-than-5' : 'more-than-5';
      this.canSlideRightDoctors = this.clinicsData?.members?.length > 5;
    }
  }

  getInitial(name: string): string {
    if (!name) return '';
    const cleanedName = name.replace(/^Dr\.?\s+/, '');

    return cleanedName.charAt(0).toUpperCase();
  }
  carouselChange(point: any) {
    this.currCarousel = this.carouselImgs.indexOf(point);
  }

  slideNxt() {
    setInterval(() => {
      this.carouselChange(this.carouselImgs[this.currCarousel]);
      this.currCarousel = (this.carouselImgs.length - 1 === this.currCarousel) ? 0 : this.currCarousel + 1;
    }, 2000);
  }


  socialNavigations(type: string) {
    switch (type) {
      case 'fb':
        let urlf = this.facebookUrl;
        if (urlf === '' || urlf === null || urlf === undefined) {
          this.openSwal();
        } else {
          if (!urlf.startsWith('http://') && !urlf.startsWith('https://')) {
            urlf = 'https://' + urlf;
          }
          window.open(urlf, '_blank');
        }
        break;
      case 'insta':
        let urli = this.instagramUrl;
        if (urli === '' || urli === null || urli === undefined) {
          this.openSwal();
        } else {
          if (!urli.startsWith('http://') && !urli.startsWith('https://')) {
            urli = 'https://' + urli;
          }
          window.open(urli, '_blank');
        }
        break;
      case 'linkedin':
        let urll = this.linkedin;
        if (urll === '' || urll === null || urll === undefined) {
          this.openSwal();
        } else {
          if (!urll.startsWith('http://') && !urll.startsWith('https://')) {
            urll = 'https://' + urll;
          }
          window.open(urll, '_blank');
        }
        break;
      case 'x':
        let urlx = this.twitterUrl;
        if (urlx === '' || urlx === null || urlx === undefined) {
          this.openSwal();
        } else {
          if (!urlx.startsWith('http://') && !urlx.startsWith('https://')) {
            urlx = 'https://' + urlx;
          }
          window.open(urlx, '_blank');
        }
        break;
      default:
        break;
    }
  }

  viewAllServices() {
    if (this.viewAll) {
      const topOfPage = document.querySelector('.servicesContainer');
      if (topOfPage) {
        topOfPage.scrollIntoView();
      }
      this.viewAll = false;
      this.servicesSize = 8;
    }
    else {
      this.viewAll = true;
      this.servicesSize = this.servicesData.length;
    }
  }

  showObserverBreakPoint() {
    this.breakpointObserver.observe([
      '(max-width: 1199px)',
      '(min-width: 1200px)'
    ]).subscribe(result => {
      if (result.matches) {
        if (result.breakpoints['(max-width: 1199px)']) {
          this.isMobileView = true;
        } else if (result.breakpoints['(min-width: 1200px)']) {
          this.isMobileView = false;
        }
      }
    })
  }

  generateQRCode() {
    const data = {
      id: this.clinicId,
      accountType: this.clinicAccountType.trim()
    }
    this.endCustomerService.generateQRCode(data).subscribe((res: any) => {
      this.clinicsData.qrCodeURL = res;
    })
  }
  openDialPad(phoneCode: any, phoneNumber: any) {
    let dialPadLink = '';
    if (phoneNumber === '' || phoneNumber === null || phoneNumber === undefined) {
      return;
    }
    if (phoneCode === '' || phoneCode === null || phoneCode === undefined) {
      dialPadLink = `tel:${phoneNumber}`;
    } else {
      dialPadLink = `tel:${phoneCode}${phoneNumber}`;
    }
    window.open(dialPadLink);
  }
  openWebsite(url: any) {
    if (url === '' || url === null || url === undefined) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank');
  }

  openSwal() {
    Swal.fire({
      position: 'center',
      title: '',
      width: '300px',
      text: 'To Be Updated Soon',
      iconHtml: '<img src="./assets/images/group-delete.svg">',
      iconColor: 'white',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      confirmButtonColor: '#0f74a9',
      backdrop: false,
      didOpen: () => {
        document.body.style.overflow = "hidden";
      },
      didClose: () => {
        document.body.style.overflow = "scroll";
      }
    })
  }  

  enableTouchScrolling() {
    const containers = [
      '.ourAdvanced-container',
      '.bestServices-container',
      '.specialityContainer',
    ];
    
    containers.forEach(selector => {
      const container = document.querySelector(selector) as HTMLElement;
      if (container) {
        container.style.overflowX = 'auto';
        container.style.overflowY = 'hidden';
        container.style.scrollBehavior = 'smooth';
        container.style.setProperty('-webkit-overflow-scrolling', 'touch');
        
        const style = document.createElement('style');
        style.textContent = `
          ${selector}::-webkit-scrollbar {
            display: none;
          }
          ${selector} {
            -ms-overflow-style: none;
            scrollbar-width: none;
            scroll-snap-type: x proximity;
          }
        `;
        document.head.appendChild(style);
        
        const children = container.children;
        for (let i = 0; i < children.length; i++) {
          (children[i] as HTMLElement).style.scrollSnapAlign = 'start';
        }
      }
    });
  }

  initTouchScrolling() {
    const containers = [
      '.ourAdvanced-container',
      '.bestServices-container',
      '.specialityContainer',
    ];
    
    containers.forEach(selector => {
      const container = document.querySelector(selector) as HTMLElement;
      if (!container) return;
      
      let startX: number;
      let scrollLeft: number;
      let startTime: number;
      let isDown = false;
      let velocity = 0;
      
      container.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX;
        scrollLeft = container.scrollLeft;
        startTime = Date.now();
        velocity = 0;
        
        container.style.scrollBehavior = 'auto';
      }, { passive: true });
      
      container.addEventListener('touchend', () => {
        if (!isDown) return;
        isDown = false;
        
        const touchDuration = Date.now() - startTime;
        if (touchDuration < 300) { 
          container.style.scrollBehavior = 'smooth';
          container.scrollLeft += velocity * 50; 
        }
        
        const containerClass = selector.substring(1);
        this.updateScrollButtons(containerClass);
      }, { passive: true });
      
      container.addEventListener('touchmove', (e) => {
        if (!isDown) return;
        
        const x = e.touches[0].pageX;
        const walk = startX - x;
        
        velocity = walk / (Date.now() - startTime);
        startTime = Date.now();
        startX = x;
        
        container.scrollLeft += walk;
      }, { passive: true });
    });
  }

  setupResponsiveScrolling() {
    const checkScreenSize = () => {
      const isMobileOrTablet = window.matchMedia('(max-width: 1024px)').matches;
      
      const arrowElements = document.querySelectorAll('.left-arrow, .right-arrow');
      
      arrowElements.forEach(el => {
        (el as HTMLElement).style.display = isMobileOrTablet ? 'none' : 'block';
      });
      
      if (isMobileOrTablet) {
        const containers = [
          '.ourAdvanced-container',
          '.bestServices-container',
          '.specialityContainer',
        ];
        
        containers.forEach(selector => {
          const container = document.querySelector(selector) as HTMLElement;
          if (container) {
            container.style.setProperty('-webkit-overflow-scrolling', 'touch');
            container.style.scrollSnapType = 'x mandatory'; 
          }
        });
      }
    };    
    checkScreenSize();    
    window.addEventListener('resize', checkScreenSize);
  }
}
